import { toast } from "react-toastify";
import {
  addTaxesFailure,
  addTaxStart,
  addTaxSuccess,
  deleteTaxStart,
  deleteTaxSuccess,
  fetchTaxesFailure,
  fetchTaxesStart,
  fetchTaxesSuccess,
  updateTaxFailure,
  updateTaxStart,
  updateTaxStatusFailure,
  updateTaxStatusStart,
  updateTaxStatusSuccess,
  updateTaxSuccess,
} from "./reducer";
import {
  addTaxMasterService,
  deleteTaxMasterService,
  getAllTaxListService,
  updateTaxMasterervice,
  updateTaxStatusService,
} from "../../Services/TaxMasterService";

export const fetchTaxList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchTaxesStart());
      const response = await getAllTaxListService(params);

      if (params.isPagination === 0) {
        dispatch(
          fetchTaxesSuccess({
            taxes: response.data,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchTaxesSuccess({
            taxes: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchTaxesFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchTaxesFailure(error));
    }
  };

export const addtaxMaster = (requestParam) => async (dispatch) => {
  try {
    dispatch(addTaxStart());

    const response = await addTaxMasterService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addTaxSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addTaxesFailure("Failed to add category"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addTaxesFailure(error));
  }
};

export const deleteTaxMaster = (taxId) => async (dispatch) => {
  try {
    dispatch(deleteTaxStart());
    const response = await deleteTaxMasterService(taxId);

    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteTaxSuccess(taxId));
    } else {
      toast.error("Something went wrong ");
      dispatch(addTaxesFailure("Failed to delete Tax Master"));
    }
  } catch (error) {
    toast.error(error || "Something went wrong");
    dispatch(addTaxesFailure(error));
  }
};

export const updateTaxMaster = (requestParam) => async (dispatch) => {
  try {
    dispatch(updateTaxStart());

    const response = await updateTaxMasterervice(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(updateTaxSuccess(response));
    } else {
      dispatch(updateTaxFailure("Failed to update category"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(updateTaxFailure(error));
  }
};

export const updateTaxStatus =
  (taxId, newStatus) => async (dispatch, getState) => {
    try {
      dispatch(updateTaxStatusStart());

      const response = await updateTaxStatusService(taxId, newStatus);
      if (response?.success) {
        // const state = getState();
        // const tax = state.taxes.find((u) => u.id === taxId);

        // if (tax) {
        //   const updatedTax = { ...tax, active };
        //   dispatch(updateTaxStatusSuccess(updatedTax));
        // }

        toast.success(response.message || "Tax status updated successfully");
      } else {
        dispatch(updateTaxStatusFailure("Failed to update user status"));
        toast.error("Failed to update user status");
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
      dispatch(updateTaxStatusFailure(error));
    }
  };
